import { Booklet_Entity } from "../entities/booklet";
import { BookletMap_Entity } from "../entities/bookletMap";
import { rhapsodyApi } from "./api";

export const missionEndpoints = rhapsodyApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicBooklet: build.query<BookletMap_Entity, string>({
      query: (token) => `booklets/public/${token}`,
      providesTags: ["booklets"],
    }),
    updateBooklet: build.mutation<void, { token: string; body: any }>({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `booklets/public/${args.token}`,
      }),
      invalidatesTags: ["booklets"],
    }),
  }),
});

export const {
  useGetPublicBookletQuery,
  useLazyGetPublicBookletQuery,
  useUpdateBookletMutation,
} = missionEndpoints;

export default missionEndpoints;
